import React from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import './style.scss'

const customDropdownStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#ffffff',
    borderColor: state.isFocused ? '#b5b5b5' : '#dcdcd5',
    borderRadius: '10px',
    minHeight: '34px',
    height: '34px',
    boxShadow: 'none',
    fontSize: '13px',
    fontWeight: '400',
    color: '#333333',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    '&:hover': {
      borderColor: '#b5b5b5',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '34px',
    padding: '0 12px',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0',
    padding: '0',
    color: '#333333',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#333333',
    margin: '0',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#6c757d',
    margin: '0',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '34px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#828282',
    padding: '0 10px',
    transition: 'transform 0.2s ease',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
    '&:hover': {
      color: '#4f4f4f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e2e8f0',
    marginTop: '4px',
    zIndex: 99,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px 0',
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '13px',
    cursor: 'pointer',
    backgroundColor: state.isSelected
      ? '#eef2f6'
      : state.isFocused
      ? '#f7fafc'
      : '#ffffff',
    color: state.isSelected ? '#1a202c' : '#4a5568',
    fontWeight: state.isSelected ? '500' : '400',
    '&:active': {
      backgroundColor: '#e2e8f0',
    },
  }),
}

function SelectDropdown({
  options = [],
  value,
  onChange,
  placeholder = 'Select...',
  isDisabled = false,
  isClearable = false,
  isSearchable = false,
  width = 'auto',
  minWidth = '160px',
  className = '',
  customStyles = {},
  ...restProps
}) {
  const mergedStyles = {
    ...customDropdownStyles,
    ...customStyles,
    control: (provided, state) => ({
      ...customDropdownStyles.control(provided, state),
      ...(customStyles.control ? customStyles.control(provided, state) : {}),
      width,
      minWidth,
    }),
  }

  return (
    <div className={`cobee-select-dropdown ${className}`}>
      <Select
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isSearchable={isSearchable}
        styles={mergedStyles}
        {...restProps}
      />
    </div>
  )
}

SelectDropdown.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  width: PropTypes.string,
  minWidth: PropTypes.string,
  className: PropTypes.string,
  customStyles: PropTypes.object,
}

export default SelectDropdown
